export interface Job<DataType = unknown, ProgressType = unknown> {
  id: string
  createdAt: number
  state: JobState
  data: DataType
  error?: Error
  progress?: ProgressType
  waitingOnTimestampMs?: number
  activeOnTimestampMs?: number
  progressOnTimestampMs?: number
  failedOnTimestampMs?: number
  completedOnTimestampMs?: number
  isCancelled?: boolean
  batchJobId?: string
  /**
   * What the run produced, saved by the runner itself. Untyped on purpose: each
   * job kind narrows it at read time with its own guard (see
   * `asBackfillSummary`), and the cache may still hold an older shape.
   */
  result?: unknown
}

export enum JobState {
  Active = 'active',
  Waiting = 'waiting',
  Failed = 'failed',
  Completed = 'completed',
  Unknown = 'unknown',
}

export const isJobStateFinished = (state: JobState): boolean =>
  state === JobState.Failed || state === JobState.Completed

export const isJobFinished = (job: Job): boolean =>
  isJobStateFinished(job.state)
